import React from 'react';

/** The one cost a patient can ever face — always stated in the same words. */
const FeeNotice: React.FC<{ compact?: boolean }> = ({ compact }) => (
  <div className={compact ? 'fine' : 'card card--fee'}>
    {!compact && <h3>The one cost to know about</h3>}
    <p>
      Some providers are allowed to charge a fee for copies of your records. If you ask us to send a request
      and the provider decides to bill for it, <strong>that fee is your responsibility</strong>, not ours, and
      we can't waive it. We tell you the moment an office says a fee applies, show it in your tracker, and let
      you decide whether to go ahead. Many offices charge nothing for electronic copies.
    </p>
  </div>
);

export default FeeNotice;
